import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Input,
} from "reactstrap";
import { updateRecivePaymnt, validateUpdateReceivePayment } from "../../util/APIUtils";
import { ProcessPayment } from "./ProcessPayment";

function ModalFullscreenExample({ OnToggle, view, currentRow, options, refresh }) {

  const [values, setValues] = useState({
    paymentType: sessionStorage.getItem("sessionPaymentTypeId") || "0",
  });


  const { initiatePayment } = ProcessPayment();


  const onUpdateHeadMap = ({ target }) => {
    const { name, value } = target;
    setValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const updatePayment = () => {
    const requiredFields = values.paymentType === "CHEQUE" ? 7 : 5;
    const errorElement = document.getElementById("error");
    errorElement.textContent = "";
    values.invoiceNumber = currentRow.invoiceNumber;

    if (values.paymentType === 'ONLINE') {
      OnToggle();
      values.invoiceNumber = currentRow.invoiceNumber;
      values.partyName = currentRow.partyName;

      handleOnlinePayment(values)
      return;
    }
    if (Object.keys(values).length !== requiredFields) {
      errorElement.textContent = "Please fill all required fields.";
      return;
    }

    if (!values.paymentType || values.paymentType === "0") {
      errorElement.textContent = "Please select a valid payment type.";
      return;
    }

    validateUpdateReceivePayment(values).then((response) => {
      if (!response.status) {
        //using swal show confirm dialog
        swal({
          title: "Are you sure?",
          text: response.msg,
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            updateRecivePaymnt(values).then(() => {
              refresh();
              OnToggle();
              sessionStorage.setItem("sessionPaymentTypeId", values.paymentType);
              setValues({
                paymentType: sessionStorage.getItem("sessionPaymentTypeId") || "0",
              });
            });
          }
        });

      } else {
        updateRecivePaymnt(values).then(() => {
          refresh();
          OnToggle();
          sessionStorage.setItem("sessionPaymentTypeId", values.paymentType);
          setValues({
            paymentType: values.paymentType,
          });
        });
      }
    });

  };

  const handleOnlinePayment = (values) => {
    initiatePayment({
      ...values
    });
  };

  const cancel = () => {
    setValues({});
    OnToggle();
  };

  return (
    <div>
      <Modal isOpen={view} toggle={OnToggle} fullscreen="false">
        <ModalBody>
          <Row className="mb-3 align-items-center">
            <Col sm="3" className="font-weight-bold">Payment Type</Col>
            <Col sm="9">
              <Input
                bsSize="sm"
                type="select"
                name="paymentType"
                id="paymentType"
                onChange={onUpdateHeadMap}
                value={values.paymentType || "0"}
              >
                <option value="0">Select</option>
                {options.map((option) => (
                  <option key={option.id} value={option.configKey}>
                    {option.configValue}
                  </option>
                ))}
              </Input>
            </Col>
          </Row>
          <Row className="mb-3 align-items-center">
            <Col sm="3" className="font-weight-bold">Balance Due</Col>
            <Col sm="9" >
              <Input
                bsSize="sm"
                type="text"
                name="bankRefNum"
                id="bankRefNum"
                value={currentRow.balance}
                autoComplete="off"
                readOnly={true}
                className="bg-light border"
              />
            </Col>
          </Row>
          {values.paymentType === "CHEQUE" && (
            <Row className="mb-3 align-items-center">
              <Col sm="3" className="font-weight-bold">Cheque No.</Col>
              <Col sm="4">
                <Input
                  bsSize="sm"
                  type="text"
                  name="cheqnum"
                  id="cheqnum"
                  maxLength={7}
                  onChange={onUpdateHeadMap}
                  value={values.cheqnum || ""}
                />
              </Col>
              <Col sm="2" className="font-weight-bold">Cheque Date</Col>
              <Col sm="3">
                <Input
                  bsSize="sm"
                  type="date"
                  name="cheqDate"
                  id="cheqDate"
                  onChange={onUpdateHeadMap}
                  value={values.cheqDate || ""}
                />
              </Col>
            </Row>
          )}
          <Row className="mb-3 align-items-center">
            <Col sm="3" className="font-weight-bold">Payment Date</Col>
            <Col sm="4">
              <Input
                bsSize="sm"
                type="date"
                name="paymentDate"
                id="paymentDate"
                onChange={onUpdateHeadMap}
                value={values.paymentDate || ""}
              />
            </Col>
            <Col sm="2" className="font-weight-bold">Received</Col>
            <Col sm="3">
              <Input
                bsSize="sm"
                type="text"
                name="amountPaid"
                id="amountPaid"
                maxLength={7}
                onChange={onUpdateHeadMap}
                value={values.amountPaid || ""}
                autoComplete="off"
              />
            </Col>
          </Row>
          <Row className="mb-3 align-items-center">
            <Col sm="3" className="font-weight-bold">Bank Ref No.</Col>
            <Col sm="4">
              <Input
                bsSize="sm"
                type="text"
                name="bankRefNum"
                id="bankRefNum"
                onChange={onUpdateHeadMap}
                value={values.bankRefNum || ""}
                autoComplete="off"
              />
            </Col>
            <Col sm="2" className="font-weight-bold">Remaining</Col>
            <Col sm="3" >
              <Input
                bsSize="sm"
                type="text"
                name="bankRefNum"
                id="bankRefNum"
                value={values.amountPaid
                  ? parseFloat(currentRow.balance - values.amountPaid).toFixed(2)
                  : currentRow.balance}
                autoComplete="off"
                readOnly={true}
                className="bg-light border"
              />
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <span id="error" style={{ color: "red", fontSize: "12px" }} />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={updatePayment}>
            Update
          </Button>
          <Button color="secondary" onClick={cancel}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default ModalFullscreenExample;


// WEBPACK FOOTER //
// ./src/components/CustomComponents/ModalFullscreenExample.js